<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    SBCCV Play
  </app-header-dialog>

  <div *ngIf="entityForm">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings_display</mat-icon>
          <div>Capa</div>
        </ng-template>

        <div class="content">

          <div>
            <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
              <mat-label>Data Entrada</mat-label>
              <input matInput [matDatepicker]="pickerIn" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.dateIn">
              <mat-datepicker-toggle matSuffix [for]="pickerIn"></mat-datepicker-toggle>
              <mat-datepicker #pickerIn></mat-datepicker>
            </mat-form-field>

            <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
              <mat-label>Data Saída</mat-label>
              <input matInput [matDatepicker]="pickerOut" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.dateOut">
              <mat-datepicker-toggle matSuffix [for]="pickerOut"></mat-datepicker-toggle>
              <mat-datepicker #pickerOut></mat-datepicker>
            </mat-form-field>

            <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
              <mat-label>Data Vídeo</mat-label>
              <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.date">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

          </div>

          <div style="display: flex; align-items: center; margin-left: 20px; margin-bottom: 20px;">
            <mat-checkbox [formControl]="entityForm.controls.tasting">Degustação</mat-checkbox>
          </div>

          <mat-form-field style='width: 620px; margin-left: 20px;' appearance="outline">
            <mat-label>Título</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.title"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 620px; margin-left: 20px;' appearance="outline">
            <mat-label>Autor</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.author"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 620px; margin-left: 20px;' appearance="outline">
            <mat-label>Vimeo</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.vimeo"
              autocomplete="off">
          </mat-form-field>

          <div style="text-align: justify;">
            <ckeditor [config]="{ 
                    toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
              [formControl]="entityForm.controls.text" [editor]="Editor"></ckeditor>
            <mat-error *ngIf="entityForm.controls.text.hasError('required')">
              O Texto é obrigatório
            </mat-error>
          </div>


        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>question_answer</mat-icon>
          <div>Imagem</div>
        </ng-template>

        <div class="content">

          <div style="margin-top: 10px; margin-left: 20px;">
            <input type="file" #fileImage (change)="onFileSelected($event)" accept="image/*, application/pdf"
              style="display:none;">
            <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
              style='background-color: whitesmoke;'>
              <mat-icon class='icon-add'>image_search</mat-icon>
              Selecionar imagem
            </a>
            <span style="margin: 0 20px 0 40px;" *ngIf="selectedFileName">{{selectedFileName}}</span>
          </div>

          <div style="display: flex; justify-content: center; width: 100%; margin: 20px;">
            <img [src]="storedImage" style="width: 400px; height: 250px;" *ngIf="storedImage">
          </div>

        </div>

      </mat-tab>

    </mat-tab-group>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
        (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>